/**
 *
 * Asynchronously loads the component for DropdownMenu
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
